﻿import React, { useState, useEffect } from 'react';
import { Formula } from '../../models/Calculators/formula';
import { CrudFunctions } from '../../utilities/crud-functions';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';

import DataGrid, {
    Column,
    Selection,
    Paging,
    HeaderFilter,
    FilterRow,
    LoadPanel
} from 'devextreme-react/data-grid';

import { TextBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';

export interface Props {
    formula: string;
    gridHeight?: string;
    onApplySelection?: (formula: Formula) => void;
    onCancel?: () => void;
}

export default function MolecularFormulaParser(props: Props) {
    const [parsedFormula, setParsedFormula] =
        useState<Formula>();

    const [rawFormula, setRawFormula] =
        useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        setInitFormula();
    }, [props.formula]);

    return (
        <div>
            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">Raw Formula</label>
                    <TextBox id="name" className="textbox"
                        onValueChanged={onValueChanged}
                        showClearButton={true}
                        placeholder="raw formula"
                        value={rawFormula ? rawFormula : undefined} />
                </div>

                <div className="pw-row-button-15">
                    <Button id="parseButton" text="Parse" icon="find" type="success"
                        hint="parse"
                        onClick={onParseClick} />
                </div>
            </div>

            {parsedFormula &&
                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Number of Nuclei</div>
                        <div className="pw-readonly-label">{parsedFormula.numberOfNuclei ?
                            parsedFormula.numberOfNuclei : undefined}</div>
                    </div>
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Molecular Mass</div>
                        <div className="pw-readonly-label">{parsedFormula.molecularMass ?
                            parsedFormula.molecularMass : undefined}</div>
                    </div>
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Uncertainty of Molecular Mass</div>
                        <div className="pw-readonly-label">{parsedFormula.uncertaintyOfMolecularMass ?
                            parsedFormula.uncertaintyOfMolecularMass : undefined}</div>
                    </div>
                </div>
            }
            <div className="pw-comp-row">
                <DataGrid width="100%" height={props.gridHeight ? props.gridHeight : "26rem"}
                    dataSource={parsedFormula && parsedFormula.elements ? parsedFormula.elements : []}
                    showBorders={true}>

                    <Paging enabled={false} />

                    <Column dataField='atomicNumber' caption="Atomic #" dataType="number" width='6rem' />
                    <Column dataField='symbol' dataType="string" width='6rem' />
                    <Column dataField='name' dataType="string" width='12rem' />
                    <Column dataField='count' dataType="number" width='6rem' />
                    <Column dataField='iupacAtomicMass' caption="IUPAC Atomic Mass" dataType="number" width='10rem' />
                    <Column dataField='iupacAtomicMassUncertainty' caption="IUPAC Atomic Mass Unc" dataType="number" width='11rem' />
                    <Column />

                </DataGrid>
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button id="applySelectionButton"
                        className="pw-button"
                        text="Apply" type="success"
                        hint="apply selection"
                        height='2rem'
                        onClick={onApplyClick} />

                    <Button id="cancelButton"
                        className="pw-button"
                        text="Cancel" type="normal"
                        hint="cancel"
                        height='2rem'
                        onClick={onCancelClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }
        </div>
    );

    function onValueChanged(e: any) {
        const caller = e.element.id;

        if (caller) 
            setRawFormula(e.value);
    }

    function onParseClick() {
        if (rawFormula) {
            parseFormula(rawFormula);
        }
    }

    function onApplyClick() {

    }

    function onCancelClick() {

    }

    async function parseFormula(rawFormula: string) {
        await CrudFunctions.getData(`calculator/parseformula/${rawFormula}`)
            .then(data => {

                console.log("parsed formula:");
                console.log(data);

                setParsedFormula(data);

            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Parsing Chemical Formula");
            });
    }

    function setInitFormula() {
        setRawFormula(props.formula);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}
